import { breakpoints } from 'const/theme';
import { MutableRefObject, useMemo } from 'react';

import { useDimension } from './useDimension';

export const useBreakpoint = (ref: MutableRefObject<HTMLElement | null>): string => {
  const { width } = useDimension(ref);

  const getBreakpoint = (width: number) => {
    const { md, lg, xl } = breakpoints.values;
    switch (true) {
      case width <= md:
        return 'Sm';
      case width >= md && width < lg:
        return 'Md';
      case width >= lg && width < xl:
        return 'Lg';
      case width >= lg:
        return 'Xl';
      default:
        return 'Sm';
    }
  };

  const breakpoint = useMemo(() => {
    return getBreakpoint(width);
  }, [width]);

  return breakpoint;
};
